export default __webpack_public_path__ + "static/media/arrowBack.34453ba0.svg";